<!-- 代理商后台菜单栏 -->
<template>
  <div class="main">
    <div v-if="username.parent_id == 0">
      <el-container>
        <el-header class="header">
          <div class="header-l">
            <img src="../assets/logo反黑.png" alt="">
          </div>
          <div class="header-r">
            <div class="enter_name">{{ username.enterpriseName }}</div>
            <el-dropdown trigger="click">
              <div class="account_name">
                <span>{{ username.account }}</span>
                <i class="el-icon-arrow-down" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item divided>
                  <span><el-link :underline="false" @click="abouts()">退出登录</el-link></span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-container class="c-height">
          <el-aside width="22rem">
            <el-menu default-active="1">
              <!-- 1首页 -->
              <el-menu-item index="1">
                <i class="iconfont icon-shouye"></i>
                <router-link to="/mine/agency/dahome" tag="div">首页</router-link>
              </el-menu-item>
              <el-submenu index="2">
                <template slot="title">
                  <i class="iconfont icon-xiansuochi"></i>线索池
                </template>
                <el-menu-item index="2-1">
                  <router-link to="/mine/agency/allocation" tag="div">线索资源</router-link>
                </el-menu-item>
              </el-submenu>
              <!-- 2系统设置 -->
              <el-submenu index="3">
                <template slot="title">
                  <i class="iconfont icon-wodekehu"></i>我的客户
                </template>
                <el-menu-item index="3-1">
                  <router-link to="/mine/agency/traded" tag="div">已成交客户</router-link>
                </el-menu-item>
              </el-submenu>
              <!-- 3代理商管理 -->
              <!-- <el-menu-item index="4">
                <router-link to="/mine/agency/prepayment" tag="div">
                  <i class="el-icon-setting"></i>预付费
                </router-link>
              </el-menu-item> -->
              <!-- 4用户管理 -->
              <el-submenu index="5">
                <template slot="title">
                  <i class="iconfont icon-wodeziliao1"></i>我的资料
                </template>
                <el-menu-item index="5-1">
                  <router-link to="/mine/agency/myProfile" tag="div">我的资料</router-link>
                </el-menu-item>
                <!-- <el-menu-item index="5-2">
                  <router-link to="/mine/agency/money" tag="div"
                    >金额记录</router-link
                  >
                </el-menu-item> -->
              </el-submenu>

              <el-submenu index="6">
                <template slot="title">
                  <i class="iconfont icon-dailishangliebiao"></i>代理商列表
                </template>
                <el-menu-item index="6-1">
                  <router-link to="/mine/agency/agent" tag="div">代理商列表</router-link>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="7">
                <template slot="title">
                  <i class="iconfont icon-jilugenzong"></i>记录跟踪
                </template>
                <el-menu-item index="7-1">
                  <router-link to="/mine/agency/tali" tag="div">跟踪记录更新</router-link>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="8">
                <template slot="title">
                  <i class="iconfont icon-caiwuzhongxin"></i>财务中心
                </template>
                <el-menu-item index="8-1">
                  <router-link to="/mine/agency/prepayment" tag="div">预付费</router-link>
                </el-menu-item>
                <el-menu-item index="8-2">
                  <router-link to="/mine/agency/money" tag="div">流水查询</router-link>
                </el-menu-item>
                <el-submenu index="8-3">
                  <template slot="title"> 发票管理 </template>
                  <el-menu-item index="8-3-1">
                    <router-link to="/mine/agency/apply" tag="div">发票申请</router-link>
                  </el-menu-item>
                  <el-menu-item index="8-3-2">
                    <router-link to="/mine/agency/invoiceand" tag="div">发票管理</router-link>
                  </el-menu-item>
                </el-submenu>
              </el-submenu>
            </el-menu>
          </el-aside>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
    <div v-else>
      <el-container>
        <el-header class="header">
          <div class="header-l">
            <img src="../assets/logo反黑.png" alt="">
          </div>
          <div class="header-r">
            <div class="enter_name">{{ username.enterpriseName }}</div>
            <el-dropdown trigger="click">
              <div class="account_name">
                <span>{{ username.account }}</span>
                <i class="el-icon-arrow-down" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item divided>
                  <span><el-link :underline="false" @click="abouts()">退出登录</el-link></span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-container class="c-height">
          <el-aside width="22rem">
            <el-menu default-active="1">
              <!-- 1首页 -->
              <el-menu-item index="1">
                <i class="iconfont icon-shouye"></i>
                <router-link to="/mine/agency/dahome" tag="div">首页</router-link>
              </el-menu-item>
              <el-menu-item index="4">
                <i class="iconfont icon-ziyuanliebiao"></i>
                <router-link to="/mine/agency/allocation" tag="div">资源列表</router-link>
              </el-menu-item>
              <el-submenu index="3">
                <template slot="title">
                  <i class="iconfont icon-wodekehu"></i>我的客户
                </template>
                <el-menu-item index="3-1">
                  <router-link to="/mine/agency/traded" tag="div">已成交客户</router-link>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="2">
                <template slot="title">
                  <i class="iconfont icon-jilugenzong"></i>记录跟踪
                </template>
                <el-menu-item index="2-1">
                  <router-link to="/mine/agency/tali" tag="div">跟踪记录更新</router-link>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="5">
                <template slot="title">
                  <i class="iconfont icon-wodeziliao1"></i>我的资料
                </template>
                <el-menu-item index="5-1">
                  <router-link to="/mine/agency/myProfile" tag="div">我的资料</router-link>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="6">
                <template slot="title">
                  <i class="iconfont icon-caiwuzhongxin"></i>财务中心
                </template>
                <el-menu-item index="6-1">
                  <router-link to="/mine/agency/money" tag="div">流水查询</router-link>
                </el-menu-item>
                <el-submenu index="6-2">
                  <template slot="title"> 发票管理 </template>
                  <el-menu-item index="6-2-1">
                    <router-link to="/mine/agency/apply" tag="div">发票申请</router-link>
                  </el-menu-item>
                </el-submenu>
              </el-submenu>
            </el-menu>
          </el-aside>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import qs from "qs";
export default {
  data() {
    return {
      username: {},
      title: {},
      carousels: "",
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }

    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    this.carousel();
  },
  methods: {
    cut() {
      this.$router.replace("/mine/agency/notice");
    },
    carousel() {
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            agent_id: this.username.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.carousels = res.data.data.content;
        })
        .catch(function (err) { });
    },
    abouts() {
      this.axios
        .post(
          "/api/user/agentOut",
          qs.stringify({
            id: this.username.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "退出成功！") {
            this.$router.replace("/mine");
          }
        })
        .catch(function (err) { });
    },
  },
  components: {},
};
</script>
<style>
.c-height {
  height: calc(100vh - 6rem);
}

/* header */
.header {
  height: 6rem !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.4rem 0 4.3rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}

.header-l img {
  width: 13.4rem;
  height: 3rem;
}

.header-r {
  display: flex;
  align-items: center;
}

.account_name {
  display: flex;
  align-items: center;
}

.enter_name,
.account_name span {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333333;
  line-height: 2.2rem;
}

.account_name span {
  margin: 0 1.9rem 0 3rem;
  cursor: pointer;
}

/* aside */
.el-aside {
  box-shadow: 1rem 0 .8rem -0.8rem rgba(0, 0, 0, 0.1);
}

.el-menu {
  border: none;
}

.el-menu-item {
  display: flex;
  color: #666;
  font-size: 1.6rem;
  height: 5.6rem;
  line-height: 5.6rem;
}

.el-submenu__title {
  color: #666;
  font-size: 1.6rem;
  padding: 0 2rem 0 3rem;
  height: 5.6rem;
  line-height: 5.6rem;
}
.el-submenu .el-menu-item {
  height: 5rem;
  line-height: 5rem;
  padding-left: 4rem !important;
}

.iconfont {
  font-size: 1.6rem;
  margin-right: 2rem !important;
}

.is-active .iconfont {
  color: #49B372 !important;
}

.el-menu-item.is-active {
  color: #0C2616;
  font-size: 1.6rem;
  background: #E6FFF1;
}
</style>
